// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import Tdg_FeedbackListModel from '../../model/tdg-feedback-list-model';
import Tdg_FeedbackListDTO from '../dto/tdg-feedback-list-dto';
import dtoSchema from '../schemas/tdg-feedback-list-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class Tdg_FeedbackListModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<Tdg_FeedbackListDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.companyId = data.companyId;
      this.organisationId = data.organisationId;
      this.companyName = data.companyName ?? undefined;
      this.organisationName = data.organisationName ?? undefined;
      this.eventRating = data.eventRating;
      this.reparticipationRating = data.reparticipationRating;
      this.youthVisitorsCount = data.youthVisitorsCount;
      this.adultVisitorsCount = data.adultVisitorsCount ?? undefined;
      this.remark = data.remark ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  * @type {int64}
  */
  companyId?: number;
  /**
  * @type {int64}
  */
  organisationId?: number;
  /**
  */
  companyName?: string;
  /**
  */
  organisationName?: string;
  /**
  * @type {int32}
  */
  eventRating?: 1 | 2 | 3; // EventRatingDTO
  /**
  * @type {int32}
  */
  reparticipationRating?: 1 | 2 | 3; // ReparticipationRatingDTO
  /**
  * @type {int32}
  */
  youthVisitorsCount?: number;
  /**
  * @type {int32}
  */
  adultVisitorsCount?: number;
  /**
  */
  remark?: string;

  static toModel(dto: DeepPartial<Tdg_FeedbackListDTO>): Tdg_FeedbackListModel;
  static toModel(dto: DeepPartial<Tdg_FeedbackListDTO> | undefined | null): Tdg_FeedbackListModel | undefined;
  static toModel(dto: DeepPartial<Tdg_FeedbackListDTO> | undefined | null): Tdg_FeedbackListModel | undefined {
    return dto ? new Tdg_FeedbackListModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<Tdg_FeedbackListModel> | Tdg_FeedbackListModel): Tdg_FeedbackListDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      companyId: unwrapped.companyId,
      organisationId: unwrapped.organisationId,
      companyName: unwrapped.companyName,
      organisationName: unwrapped.organisationName,
      eventRating: unwrapped.eventRating,
      reparticipationRating: unwrapped.reparticipationRating,
      youthVisitorsCount: unwrapped.youthVisitorsCount,
      adultVisitorsCount: unwrapped.adultVisitorsCount,
      remark: unwrapped.remark,
    } as Tdg_FeedbackListDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for Tdg_FeedbackListModel, can not map to Tdg_FeedbackListDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
